export default ['SurveyTemplate', 'SurveyTemplateCategory'];
